module.exports = __webpack_public_path__ + "static/media/christian-dior-sauvage-big.23a8440b.png";